<template>
  <section class="home-loading-panel">
    <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    <div class="loading-text">Preparando tu espacio de escritura...</div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HomeLoadingOverlay',
})
</script>

<style scoped>
.home-loading-panel {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f7f9fb 0%, #e8f4f8 100%);
  padding: 2rem 1rem 3rem;
}

.loading-text {
  color: #1d3557;
  margin-top: 1rem;
  font-size: 1.2rem;
  font-weight: 500;
}
</style>
